import{hasSupport as t,wrap as e,get as l,set as o,remove as a}from"@analytics/global-storage-utils";var r="localStorage",m=t.bind(null,r),g=e(r,"getItem",l),i=e(r,"setItem",o),s=e(r,"removeItem",a);export{r as LOCAL_STORAGE,g as getItem,m as hasLocalStorage,s as removeItem,i as setItem};
//# sourceMappingURL=analytics-util-localstorage.module.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@analytics/localstorage-utils/dist/analytics-util-localstorage.module.js
// module id = I7CY
// module chunks = 0